import "./questionnaire.css";

import { Button, Form, Badge, Card } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Multiselect from "multiselect-react-dropdown";
import React from "react";
import { surveyActions } from "../../actions";
import { throttle } from "lodash";
import { useApi } from "../../contexts/ApiProvider";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useUser } from "../../contexts/UserProvider";
import { parsePtObjDates } from "../../utils/parsers";

export default function Questionnaire() {

  const patient = useSelector((state) => state.patient);
  const ptObjOriginal = useSelector((state) => state.patient.patient); // can remove if all variables fixed
  const contact_list = useSelector((state) => state.patient.contact_list);
  const activeCase = useSelector((state) => state.survey.activeCase);
  const reduxForm = useSelector((state) => state.survey.form);  // the stored form
  const surveyHistoryForActiveCase = useSelector((state) => 
    state.survey.surveyHistory[activeCase?.micro_id]
  );
  const { user, save, isAdmin } = useUser();
  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [ptObj, setPtObj] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false); // for current form status expandable (debugging)

  const [form, setForm] = useState(null);

  const [currentQuestion, setCurrentQuestion] = useState(0);

  console.log('patient', patient);

  console.log('locations', patient.patient.locations);

  // const [selectedWardList, setSelectedWardList] = useState([]);

  // const [filteredSources, setFilteredSources] = useState([]);

  // console.log('form', form);

  const fetchPtData = async () => {
    const response = await api.get(
      // TODO can change between overlap levels
      // TODO fix other variables too for questionnaire
      `/pt/${patient.micro_id}/level/hospital/incubation/${ptObjOriginal.incubation}/inf_period_before/${ptObjOriginal.inf_period_before ? ptObjOriginal.inf_period_before : 0}/inf_period_after/${ptObjOriginal.inf_period_after}/contam/${ptObjOriginal.contam_period}/test_time_buffer/${ptObjOriginal.test_time_buffer}`
    );
    if (response.ok) {
      const result = response.body;
      console.log('result', result);
      setPtObj(result);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    fetchPtData();
  }, []);

  useEffect(() => {

    // console.log('activeCase', activeCase);
    // console.log('surveyHistory', surveyHistoryForActiveCase);

    // (1) If we have a user or activeCase, check if there's a stored form for that same case.
    if (user && activeCase) {
      // Decide if the existing Redux form belongs to the same case
      if (reduxForm?.case_id === activeCase.case_id) {
        // Re-use it
        setForm(reduxForm);
        setCurrentQuestion(reduxForm.current_question || 0);
      } else {
        // Otherwise, create a new form
        const activeCaseMode = activeCase
        ? surveyHistoryForActiveCase?.mode || -1
        : -1;
      
        const newForm = {
          participant_id: user?.id || -1, // this should be the user id
          case_id: activeCase.case_id,
          // case_order:
          micro_id: activeCase.micro_id,
          patient_id: activeCase.patient_mrn,
          patient_name: activeCase.patient_name,
          phase: activeCaseMode,
          questions: [],
          start_timestamp: activeCase.start_timestamp,
          submit_timestamp: "",
          current_question: 0,
        };

        setForm(newForm);
        setCurrentQuestion(0);
        // Also store it in Redux
        dispatch(surveyActions.updateSurveyForm(newForm));
      }
    }
  }, [user, activeCase, reduxForm, surveyHistoryForActiveCase, dispatch]);

  const data = ptObj ? parsePtObjDates(ptObj, ptObj.constrain, ptObj.overlap_level) : null;

  console.log('ptObj', ptObj);

  console.log('datadata', data);

  const source_list = data ? data.source_list : [];

  // console.log('source_list', source_list);

  // const ward_list = source_list ? source_list.map(({ ward }) => ward) : [];
  // ward_list.sort();
  
  // Wards from source_list
  const wardsFromSources = React.useMemo(() => {
    return (data?.source_list || []).map(({ ward }) => ward).filter(Boolean);
  }, [data?.source_list]);

  console.log('wardsFromSources', wardsFromSources);

  // Wards from patient.patient.locations
  const wardsFromLocations = React.useMemo(() => {
    const locs = data?.locations || [];
    // ward in locations corresponds exactly to source_list. De-dup + keep only truthy.
    return Array.from(new Set(locs.map(l => l?.ward).filter(Boolean)));
  }, [data?.locations]);

  console.log('wardsFromLocations', wardsFromLocations);

  // Combine ward list from both sources and locations, de-dup and sort
  const ward_list = React.useMemo(() => {
    const set = new Set(wardsFromSources);
    for (const w of wardsFromLocations) set.add(w);
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [wardsFromSources, wardsFromLocations]);

  // console.log('ward_list', ward_list);

  // console.log('patient', patient);

  const { handleCloseSurvey } = useSurveyMode();
  //const dispatch = useDispatch();
  // const { user, logout } = useUser();

  const endSurvey = () => {
    navigate('/explore');
  };


  const handleChange = ({
    questionIndex = null,
    questionText = null,
    responseIndex = null,
    responseText = null,
    responseValue = null,
    responseConf = null,
    responseTimestamp = null,
    responseWardIndex = null,  //For Q6
    responseWardName = null,  //For Q6
  }) => {

    // Copy current form state
    const updatedForm = JSON.parse(JSON.stringify(form));
    
    const updatedQuestions = updatedForm.questions.length ? [...updatedForm.questions] : [];

    // Create question object if it doesn't already exist
    if (!updatedQuestions[questionIndex]) {
      updatedQuestions[questionIndex] = {
        question_id: questionIndex,
        question_text: questionText,
        responses: []
      };
    }

    let updatedResponses = updatedQuestions[questionIndex].responses.length ? [...updatedQuestions[questionIndex].responses] : [];

    if (!updatedResponses[responseIndex]) {
      updatedResponses[responseIndex] = {
        response_id: responseIndex,
        response_text: responseText,
        response_value: responseValue,
        response_confidence: responseConf,
        response_timestamp: Date.now(),
        response_ward_index: responseWardIndex, // For Q6
        response_ward_name: responseWardName, // For Q6
      };
    } else {
      if (responseText !== null) updatedResponses[responseIndex].response_text = responseText;
      if (responseValue !== null) updatedResponses[responseIndex].response_value = responseValue;
      if (responseConf !== null) updatedResponses[responseIndex].response_confidence = responseConf;
      if (responseTimestamp !== null) updatedResponses[responseIndex].response_timestamp = responseTimestamp;
      // For Q6 only:
      if (responseWardIndex !== null) updatedResponses[responseIndex].response_ward_index = responseWardIndex;
      if (responseWardName !== null) updatedResponses[responseIndex].response_ward_name = responseWardName;
    }

    // Handle the logic for single select options
    // For question 5:
    if (questionIndex === 4) {
      if (responseValue) {
        // Define the block (set of 4 responses) for the current ward:
        const startIndex = responseWardIndex * 4;
        const endIndex = startIndex + 4;
        if (questions[questionIndex].options[responseIndex].single_answer) {
          // If a single_answer option is selected for this ward, clear all other responses in that block.
          for (let i = startIndex; i < endIndex; i++) {
            if (i !== responseIndex && updatedResponses[i]) {
              updatedResponses[i].response_value = false;
              updatedResponses[i].response_confidence = null;
            }
          }
        } else {
          // For non single_answer selection, clear any previously selected single_answer option in this ward block.
          for (let i = startIndex; i < endIndex; i++) {
            const optionForI = questions[questionIndex].options[i];
            if (optionForI && optionForI.single_answer && updatedResponses[i]) {
              updatedResponses[i].response_value = false;
              updatedResponses[i].response_confidence = null;
            }
          }
        }
      }
    } else {
      // For other questions:
      if (responseValue) {
        if (questions[questionIndex].options[responseIndex].single_answer) {
          // If a single_answer option is selected, clear all other responses.
          updatedResponses = updatedResponses.map((response, index) => ({
            ...response,
            response_value: index === responseIndex,
            response_confidence: index === responseIndex ? responseConf : null
          }));
        } else {
          // For non single_answer selection, clear any previously selected single_answer option.
          updatedResponses = updatedResponses.map((response, index) => {
            if (questions[questionIndex].options[index].single_answer && response?.response_id !== undefined) {
              return {
                ...response,
                response_value: false,
                response_confidence: null
              };
            }
            return response;
          });
        }
      }
    }

    updatedQuestions[questionIndex] = { 
      ...updatedQuestions[questionIndex], 
      responses: updatedResponses 
    };

    setForm({ ...updatedForm, questions: updatedQuestions });
    dispatch(surveyActions.updateSurveyForm({ ...updatedForm, questions: updatedQuestions }));
    
    // Update selected wards if the current question is Q3
    if (questionIndex === 2) {
      const selectedWards = updatedResponses.filter(response => response?.response_value).map(response => response.response_text);
      // setSelectedWardList(selectedWards);
      // console.log('Selected wards:', selectedWards)
  
      // extract sources from source_list if ward is in ward_list
      const sources = source_list
        .filter(({ ward }) => selectedWards.includes(ward)) // Use selectedWards here
        .map(({ sources }) => sources)
        .flat();
  
      // remove duplicates if label is the same
      const unique_sources = Array.from(new Set(sources.map(a => a.label)))
        .map(label => {
          return sources.find(a => a.label === label)
        });
      unique_sources.sort((a, b) => a.label.localeCompare(b.label));
      // setFilteredSources(unique_sources);
  
      // console.log('unique sources', unique_sources);
    }
  };

  // Wards selected in Q3, derived from saved form
  const selectedWardsFromForm = React.useMemo(() => {
    const q3Responses = form?.questions?.[2]?.responses || [];
    return q3Responses
      .filter(r => r?.response_value)
      .map(r => r.response_text);
  }, [form]);

  const normalizePatientName = React.useCallback(
    value => String(value || "").split(",")[0].trim().toLowerCase(),
    []
  );

  const activeIndexMicroId = String(activeCase?.micro_id ?? patient?.micro_id ?? "");
  const indexPatientName = String(activeCase?.patient_name ?? patient?.patient?.pt?.name ?? "");
  const relevantIndexWard = patient?.patient?.pt?.ward_first_positive
    ? patient?.patient?.pt?.ward_first_positive
    : patient?.patient?.pt?.most_recent_ward;

  // Match CaseList's filteredContacts behaviour: keep only contacts on the index ward.
  const filteredContacts = React.useMemo(() => {
    return relevantIndexWard && contact_list?.[relevantIndexWard]?.length > 0
      ? { [relevantIndexWard]: contact_list[relevantIndexWard] }
      : {};
  }, [relevantIndexWard, contact_list]);

  // For Q4: Compute filtered sources from selected wards + source_list
  const computedFilteredSources = React.useMemo(() => {
    const selected = selectedWardsFromForm || [];
    const selectedWardSources = (source_list || [])
      .filter(({ ward }) => selected.includes(ward))
      .flatMap(({ sources }) => sources || []);

    const map = new Map(); // de-dup by label
    for (const s of selectedWardSources) {
      if (s?.label && !map.has(s.label)) map.set(s.label, s);
    }

    // De-dup contacts by name against already-included source_list patients.
    const existingNames = new Set(
      Array.from(map.values()).map(s => normalizePatientName(s?.label))
    );

    const shouldIncludeIndexWardContacts =
      Boolean(relevantIndexWard) &&
      selected.includes(relevantIndexWard) &&
      String(patient?.micro_id ?? "") === activeIndexMicroId;

    if (shouldIncludeIndexWardContacts) {
      const indexWardContacts = filteredContacts[relevantIndexWard] || [];
      const indexNameKey = normalizePatientName(indexPatientName);

      for (const contact of indexWardContacts) {
        const fullName = `${contact?.firstname || ""} ${contact?.surname || ""}`.trim();
        if (!fullName) continue;

        const nameKey = normalizePatientName(fullName);
        if (!nameKey || nameKey === indexNameKey || existingNames.has(nameKey)) continue;

        const patientId =
          contact?.patient_id ?? contact?.micro_id ?? contact?.pid ?? contact?.hospital_number;
        const label = patientId ? `${fullName}, ${patientId}` : fullName;

        map.set(label, {
          ...contact,
          ward: relevantIndexWard,
          label,
          pid: String(patientId || fullName),
        });
        existingNames.add(nameKey);
      }
    }

    return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
  }, [
    selectedWardsFromForm,
    source_list,
    normalizePatientName,
    relevantIndexWard,
    filteredContacts,
    patient?.micro_id,
    activeIndexMicroId,
    indexPatientName,
  ]);

  console.log('computedFilteredSources', computedFilteredSources);

  // --- Extra patients from the phylo tree (patient.tree.name_map_snp2) ---
  const extraPatientsFromTree = React.useMemo(() => {
    const nameMap = patient?.tree?.name_map_snp2 || {};
    const entries = Object.entries(nameMap);

    if (!activeIndexMicroId || entries.length === 0) return [];

    // Index patient's sequencing date (from name_map_snp2)
    const indexEntry = entries.find(([, arr]) => String(arr?.[1]) === activeIndexMicroId);
    // If the tree snapshot does not contain the active index patient, it is stale.
    if (!indexEntry) return [];

    const indexSeqDateStr = indexEntry?.[1]?.[2];
    const indexSeqDate = indexSeqDateStr ? new Date(indexSeqDateStr) : null;

    // Names already present in the base Q4 list (computedFilteredSources)
    // The base labels are often "Name, 12345" — normalize to just "name"
    const baseNames = new Set(
      (computedFilteredSources || [])
        .map(s => (s?.label || "").split(",")[0].trim().toLowerCase())
    );

    console.log('baseNames', baseNames);

    // Build extras, excluding:
    //  - index patient
    //  - anyone sequenced later than index
    //  - anyone whose name already appears in the base list
    const extrasByName = new Map(); // dedupe extras by name
    for (const [, arr] of entries) {
      const [name, microId, seqDateStr] = arr || [];
      if (!name) continue;

      const nameKey = String(name).trim().toLowerCase();

      // exclude index patient
      if (String(microId) === activeIndexMicroId) continue;

      // exclude if sequenced after index
      if (indexSeqDate && seqDateStr) {
        const d = new Date(seqDateStr);
        if (d > indexSeqDate) continue;
      }

      // exclude if base already has this name
      if (baseNames.has(nameKey)) continue;

      // keep only first seen per unique name
      if (!extrasByName.has(nameKey)) {
        const label = microId ? `${name}, ${microId}` : name;
        extrasByName.set(nameKey, { label, pid: String(microId || name) });
      }
    }
    console.log('extrasByName', extrasByName);

    // Return a sorted array by label
    return Array.from(extrasByName.values()).sort((a, b) => a.label.localeCompare(b.label));
  }, [patient?.tree?.name_map_snp2, activeIndexMicroId, computedFilteredSources]);

  // --- Final Q4 patients: computedFilteredSources + extraPatientsFromTree ---
  const q4Patients = React.useMemo(() => {
    // Normalize base into {label, pid}, and build a set of names for safety
    const base = (computedFilteredSources || []).map(s => ({
      label: s.label,
      pid: String(s.pid)
    }));
    const baseNames = new Set(
      base.map(b => b.label.split(",")[0].trim().toLowerCase())
    );

    // Keep extras only if their name isn't already present (double-safety)
    const extras = extraPatientsFromTree.filter(
      p => !baseNames.has(p.label.split(",")[0].trim().toLowerCase())
    );

    const combined = [...base, ...extras];
    combined.sort((a, b) => a.label.localeCompare(b.label));
    return combined;
  }, [computedFilteredSources, extraPatientsFromTree]);

  console.log('extraPatientsFromTree', extraPatientsFromTree);
  console.log('q4Patients', q4Patients);

  // For Q5: exclude "Other ward(s)/location(s)" and always append a generic ward
  const wardListForQ5 = React.useMemo(() => {
    const filtered = (selectedWardsFromForm || []).filter(
      w =>(w !== "Other ward(s)/location(s)") && (w !== "Cannot be determined based on information available")
    );
    if (!filtered.includes("Specialty/hospital-wide interventions")) {
      filtered.push("Specialty/hospital-wide interventions");
    }
    return filtered;
  }, [selectedWardsFromForm]);

  const conf_text = "How confident are you in your response? \n <i>(1 = not at all confident; 5 = fairly sure; 10 = very confident)</i>";
  const select_all_text = "Select ALL that apply";
  
  const questions = [
    {
      question_id: 1,
      question_text: "Q1. From the information presented, where do you think this patient could have potentially acquired C. difficile?",
      type: "checkbox",
      with_conf: true,
      select_all_text: select_all_text,
      conf_text: conf_text,
      options: [
        { label: "In the hospital", value: 1, with_conf: true},
        { label: "In the community", value: 2, with_conf: true},
        { label: "Cannot be determined based on information available", value: -1, with_conf: false, single_answer: true},
      ],
    },
    {
      question_id: 2,
      question_text: "Q2. If acquired in the hospital, where do you think transmission potentially occurred?",
      type: "checkbox",
      with_conf: true,
      select_all_text: select_all_text,
      conf_text: conf_text,
      options: [
        { label: "Within the same ward, via direct patient-to-patient transmission", value: 1, with_conf: true},
        { label: "Within the same ward, via environmental contamination persisting after patient discharge (e.g. through contaminated environments, healthcare workers, shared medical equipment or devices)", value: 2, with_conf: true},
        // { label: "Across different wards within the same specialty", value: 2, with_conf: true},
        { label: "Across different wards (e.g. through healthcare workers)", value: 3, with_conf: true},
        { label: "Cannot be determined based on information available", value: -1, with_conf: false, single_answer: true},
      ],
    },
    // {
    //   question_id: 3,
    //   question_text: "Q3. How do you think transmission potentially occurred in the hospital? (select all that apply)",
    //   type: "checkbox",
    //   with_conf: true,
    //   select_all_text: "Select ALL that apply",
    //   conf_text: "How confident are you in your response? (1 = a possibility but unlikely; 5 = fairly sure; 10 = very confident)",
    //   options: [
    //     { label: "Direct patient-to-patient transmission", value: 1, with_conf: true},
    //     { label: "Transmission through healthcare workers, shared medical equipment or devices", value: 2, with_conf: true},
    //     { label: "Environmental contamination persisting after patient discharge", value: 3, with_conf: true},
    //     { label: "Cannot be determined based on information available", value: -1, with_conf: false, single_answer: true},
    //   ],
    // },
    {
      question_id: 3,
      question_text: "Q3. Please select all ward(s) where potential source(s) of transmission could be found.",
      type: "checkbox",
      with_conf: true,
      select_all_text: select_all_text,
      conf_text: conf_text,
      options: [
        ...ward_list.map((ward, index) => ({
          label: ward,
          value: index,
          with_conf: true,
        })),
        { label: "Other ward(s)/location(s)", value: -2, with_conf: true },
        { label: "Cannot be determined based on information available", value: -1, with_conf: false, single_answer: true },
      ],
    },
    {
      question_id: 4,
      question_text: "Q4. Please select all patient(s) you think could be the potential source(s) of transmission, including the potential source(s) of ward contamination that you think led to this transmission.",
      type: "checkbox",
      with_conf: true,
      select_all_text: select_all_text,
      conf_text: conf_text,
      options: [
        ...q4Patients.map((source, index) => ({
          label: source.label,
          value: source.pid,
          with_conf: true,
        })),
        { label: "Other potential source(s) of transmission", value: -1, with_conf: true },
        { label: "Cannot be determined based on information available", value: -1, with_conf: false, single_answer: true },
      ],
    },
    {
      question_id: 5,
      question_text: "Q5. In addition to isolating the patient and reviewing their antibiotics, what would be your recommended course of action for each ward?",
      type: "checkbox",
      with_conf: true,
      select_all_text: select_all_text,
      conf_text: conf_text,
      options: wardListForQ5.flatMap((ward, wIndex) => {
        const offset = wIndex * 4;
        return [
          { label: `No other action needed in addition to isolating the patient and reviewing their antibiotics`, value: offset, with_conf: true, single_answer: true },
          { label: `Reinforcing contact precaution and hand hygiene (possibility of patient-to-patient transmission)`, value: offset + 1, with_conf: true },
          { label: `Enhanced ward cleaning and equipment decontamination (possibility of ward contamination)`, value: offset + 2, with_conf: true },
          { label: `Cannot be determined based on information available`, value: offset + 3, with_conf: false, single_answer: true },
        ];
      }),
    },
  ]

  const totalQuestions = 5;

// Check if Q4 (transmission source selection) should be skipped
const shouldSkipQ4 = () => {
  const q3Responses = form?.questions?.[2]?.responses || [];
  const selectedValues = q3Responses
    .filter(r => r?.response_value)
    .map(r => questions[2]?.options?.[r.response_id]?.value);

  if (selectedValues.includes(-1)) {
    // Cannot be determined => always skip Q4
    return true;
  }

  if (selectedValues.length === 1 && selectedValues[0] === -2) {
    // Only "Other ward(s)/location(s)" selected => skip Q4; don't skip if selected with other wards
    return true;
  }

  // Otherwise, don't skip
  return false;
};

  const handleNext = () => {

    // If we're on Q3, check if we should skip Q4
    if (currentQuestion === 2 && shouldSkipQ4()) {
      const nextIndex = 4; // jump to Q5 (index 4)
      setCurrentQuestion(nextIndex);
      const updated = { ...form, current_question: nextIndex };
      setForm(updated);
      dispatch(surveyActions.updateSurveyForm(updated));
      return;
    }

    if (currentQuestion < totalQuestions - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setForm({ ...form, current_question: currentQuestion + 1 });
      dispatch(surveyActions.updateSurveyForm({ ...form, current_question: currentQuestion + 1 }));
    }
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      let prevQuestion = currentQuestion - 1;

      // If we're at Q5 (index 4) and Q4 was skipped, jump back to Q3 (index 2)
      if (currentQuestion === 4 && shouldSkipQ4()) {
        prevQuestion = currentQuestion - 2;
      }

      // Ensure responses in future questions are removed if user goes back
      const updatedForm = form ? { ...form } : { questions: [] };
      updatedForm.questions = updatedForm.questions.slice(0, currentQuestion);
      updatedForm.current_question = prevQuestion;
      setForm(updatedForm);
      setCurrentQuestion(prevQuestion);
      dispatch(surveyActions.updateSurveyForm(updatedForm));
    }
  };

  const isCurrentQuestionAnswered = () => {
    const currentQ = form.questions[currentQuestion];
    if (!currentQ || !currentQ.responses || currentQ.responses.length === 0) return false;
  
    return currentQ.responses.some(response => {
      const question = questions[currentQuestion];
      const option = question.options[response?.response_id];
      return response?.response_value && (option?.with_conf === false || response?.response_confidence !== null);
    }) &&
    !currentQ.responses.some(response => {
      const question = questions[currentQuestion];
      const option = question.options[response?.response_id];
      return response?.response_value && option?.with_conf && (response?.response_confidence === 0 || response?.response_confidence === null);
    });
  };

  const isLastQuestion = () => {
    if (currentQuestion === totalQuestions - 1) {
      return true;
    }

    // Special case for Q1, if only selected in the community or cannot be determined is selected, end survey
    if (currentQuestion === 0) {
      const firstQuestionResponses = form.questions[0]?.responses || [];
      const inHospitalSelected = firstQuestionResponses.some(response => response?.response_text === "In the hospital" && response?.response_value);
      const inCommunitySelected = firstQuestionResponses.some(response => response?.response_text === "In the community" && response?.response_value);
      const cannotBeDeterminedSelected = firstQuestionResponses.some(response => response?.response_text === "Cannot be determined based on information available" && response?.response_value);
      return (inCommunitySelected || cannotBeDeterminedSelected) && !inHospitalSelected;
    }

    return false;
  };

  const submitButton = async (e) => {
    // TODO add submit functionality
    e.preventDefault();
    // run_api(form); //TODO add back in
    // resetButton(); // TODO add back in
    // const now = new Date().toISOString();
    if (surveyHistoryForActiveCase === undefined) {
      console.log('Error: surveyHistoryForActiveCase is undefined.');
    } else if (surveyHistoryForActiveCase.mode >= 4) {
      console.log('Error: survey already completed (surveyHistoryForActiveCase.mode === 4).');
    } else {

      // Submit response form
      // Update form submit_timestamp with current time
      const updatedForm = { ...form, submit_timestamp: Date.now()};
      setForm(updatedForm);

      const response = await api.post("/me/response", updatedForm);
      if (!response.ok) {
        console.error("Error saving user_response:", response);
        // maybe show error alert
        return;
      }
      console.log("User response saved successfully", response);

      // Update progress
      dispatch(
        surveyActions.storeSurveyedObj(
          activeCase.micro_id,
          activeCase.case_id,
          activeCase.patient_mrn,
          activeCase.patient_name,
          surveyHistoryForActiveCase.mode + 1,
        )
      );

      // Reset activeCase.start_timestamp
      dispatch(
        surveyActions.storeActiveCase({
          case_id: activeCase.case_id,
          patient_mrn: activeCase.patient_mrn,
          patient_name: activeCase.patient_name,
          micro_id: activeCase.micro_id,
          start_timestamp: Date.now(),
        })
      );

      // TODO Update survey store ???

      // Clear the current stored form
      dispatch(surveyActions.clearSurveyForm());

      // Save progress to the backend
      setTimeout(async () => {
        await save();
      }, 0);

      // Close the survey slider
      handleCloseSurvey();

      // Return to the explore page if all phases of the survey is completed
      if (surveyHistoryForActiveCase.mode === 3) {
        console.log('End of survey.');
        endSurvey();
      }
    }
  };

  const wardBadgeVariant = (ward, i) => {
    if (ward === "Specialty/hospital-wide interventions") return "dark";
    const variants = ["primary", "success", "info", "warning", "secondary", "danger"];
    return variants[i % variants.length];
  };

  const semiboldOptionLabels = new Set([
    "Cannot be determined based on information available",
    "Other ward(s)/location(s)",
    "Other potential source(s) of transmission",
  ]);

  // If an option label is in the semiboldOptionLabels set, render it with a semibold font weight
  const getOptionLabel = (label) => (
    semiboldOptionLabels.has(label)
      ? <span style={{ fontWeight: 450 }}>{label}</span>
      : label
  );

  // If an option is in the semiboldOptionLabels set, show a separator line above it, unless the previous option is also in the set
  const shouldShowSpecialOptionSeparator = (options, index) => {
    const currentLabel = options?.[index]?.label;
    if (!semiboldOptionLabels.has(currentLabel)) return false;
    if (index === 0) return true;
    const previousLabel = options?.[index - 1]?.label;
    return !semiboldOptionLabels.has(previousLabel);
  };
  
  return (
    <div>
      {!form ? (
        <Spinner />
      ) : (
        <Form>
          <Button variant="outline-secondary border-0" onClick={handleCloseSurvey} style={{marginLeft: "-12px"}}>← Return to Dashboard</Button>
          <Form.Group>
          <Form.Label>
            <h5>{questions[currentQuestion].question_text}</h5>
            {currentQuestion === 2 && (
              <div >
                <i>N.B. Not all locations shown here will be relevant to this case or phase, you may safely ignore them, or choose "other ward(s)", or "cannot be determined" if applicable.</i>
              </div>
            )}
            {currentQuestion === 3 && (
              <div >
                <i>N.B. This list is restricted by your choice in the previous question.</i>
              </div>
            )}
          </Form.Label>
          {/* Check if any option is selected and render the label conditionally
          {questions[currentQuestion].options.some((option, idx) => form.questions[currentQuestion]?.responses[idx]?.response_value) && ( */}
          <span className="badge bg-danger rounded-pill" style={{ fontSize: "14px", pointerEvents: "none", marginBottom: "15px" }}>
            {questions[currentQuestion].select_all_text}
          </span>
          <div
            style={{
              flex: "1",
              color: "grey",
              fontSize: "14px",
              marginBottom: "20px",
              whiteSpace: "pre-line", // makes \n become line breaks
            }}
            dangerouslySetInnerHTML={{ __html: questions[currentQuestion].conf_text }}
          />
          {currentQuestion !== 4 && (
            <Card className="mb-3 shadow-sm" style={{ borderColor: "#eee" }}>
              <Card.Body className="py-3">
                {/* 🔔 Q4: show a warning when there are no pre-selected patients */}
                {currentQuestion === 3 && computedFilteredSources.length === 0 && (
                  <div className="alert alert-info py-2" role="alert" style={{ fontSize: 14, color: "grey" }}>
                    No pre-selected patients were found for the ward(s) you selected in Q3.
                    You can still proceed and choose <b>“Other potential source(s) of transmission”</b> if relevant.
                  </div>
                )}
                {currentQuestion !== 4 && questions[currentQuestion].options.map((option, index) => {
                  const isSelected = form.questions[currentQuestion]?.responses[index]?.response_value || false;
                  const hasSpecialSeparator = shouldShowSpecialOptionSeparator(
                    questions[currentQuestion].options,
                    index
                  );
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '10px',
                        marginRight: '10px',
                        marginTop: hasSpecialSeparator ? '14px' : undefined,
                        paddingTop: hasSpecialSeparator ? '10px' : undefined,
                        borderTop: hasSpecialSeparator ? '1px solid #d8d8d8' : undefined,
                      }}
                    >
                      <div style={{ flex: '5' }}>
                        <Form.Check 
                            id={index + 1}
                            type={questions[currentQuestion].type}
                            label={getOptionLabel(option.label)}
                            checked={isSelected}
                            onChange={(e) => handleChange({
                              questionIndex: currentQuestion,
                              questionText: questions[currentQuestion].question_text,
                              responseIndex: index,
                              responseText: option.label,
                              responseValue: e.target.checked,
                              responseTimestamp: Date.now()
                            })}
                        />
                      </div>
                      <div style={{ flex: '1' }}></div>
                      <div style={{ flex: '5' }}>
                        {isSelected && questions[currentQuestion].with_conf && option.with_conf === true && (
                          <div style={{ alignItems: 'center' }}>
                            <Form.Label style={{ fontSize: 'small', marginBottom: 0, marginTop: 0 }}>
                              Confidence:{" "}
                              <span style={{ color: form.questions[currentQuestion]?.responses[index]?.response_confidence ? "black" : "red" }}>
                                {form.questions[currentQuestion]?.responses[index]?.response_confidence || "Please Select"}
                              </span>
                            </Form.Label>
                            <Form.Range 
                                min="1"
                                max="10"
                                value={form.questions[currentQuestion]?.responses[index]?.response_confidence || 5} // Default or stored confidence value
                                onChange={(e) => handleChange({
                                  questionIndex: currentQuestion,
                                  questionText: questions[currentQuestion].question_text,
                                  responseIndex: index,
                                  responseText: option.label,
                                  responseConf: e.target.value,
                                  responseTimestamp: Date.now()
                                })}
                                style={{ marginTop: '-5px' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                  );
                })}
              </Card.Body>
            </Card>
          )}
          {/* Special case for Q6 to sort options into wards */}
          {currentQuestion === 4 && wardListForQ5.map((ward, wardIndex) => {
  // For each ward, slice out the 4 choices for that ward
            const start = wardIndex * 4;
            const wardOptions = questions[currentQuestion].options.slice(start, start + 4);

            return (
              <Card key={wardIndex} className="mb-3 shadow-sm" style={{ borderColor: "#eee" }}>
                <Card.Body className="py-3">
                  <div className="d-flex align-items-center mb-2">
                    <Badge pill bg={wardBadgeVariant(ward, wardIndex)} className="me-2" style={{fontSize: 14, pointerEvents: "none"}}>
                      {ward === "Specialty/hospital-wide interventions" ? "Specialty & Hospital-wide" : ward}
                    </Badge>
                    <div className="text-muted small">Select action(s) {ward === "Specialty/hospital-wide interventions" ? "" : "for this ward"}</div>
                  </div>
                  
                  {wardOptions.map((option, index) => {
                    // Compute an overall unique index for the response.
                    const overallIndex = wardIndex * 4 + index;
                    const isSelected = form.questions[currentQuestion]?.responses[overallIndex]?.response_value || false;
                    const hasSpecialSeparator = shouldShowSpecialOptionSeparator(wardOptions, index);

                    return (
                      <div
                        key={overallIndex}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '10px',
                          marginRight: '10px',
                          marginLeft: '10px',
                          marginTop: hasSpecialSeparator ? '14px' : undefined,
                          paddingTop: hasSpecialSeparator ? '10px' : undefined,
                          borderTop: hasSpecialSeparator ? '1px solid #d8d8d8' : undefined,
                        }}
                      >
                        <div style={{ flex: '8' }}>
                          <Form.Check
                            id={`q5-${overallIndex + 1}`}
                            type="checkbox"
                            label={getOptionLabel(option.label)}
                            checked={isSelected}
                            onChange={(e) =>
                              handleChange({
                                questionIndex: currentQuestion,
                                questionText: questions[currentQuestion].question_text,
                                responseIndex: overallIndex,
                                responseWardIndex: wardIndex,
                                responseWardName: ward,
                                responseText: option.label,
                                responseValue: e.target.checked,
                                responseTimestamp: Date.now(),
                              })
                            }
                          />
                        </div>
                        <div style={{ flex: '1' }}></div>
                        <div style={{ flex: '5' }}>

                          {isSelected && option.with_conf && (
                            <div style={{ alignItems: 'center' }}>
                              <Form.Label style={{ fontSize: "small", marginBottom: 0, marginTop: 0 }}>
                                Confidence:{" "}
                                <span
                                  style={{
                                    color:
                                      form.questions[currentQuestion]?.responses[overallIndex]?.response_confidence
                                        ? "black"
                                        : "red",
                                  }}
                                >
                                  {form.questions[currentQuestion]?.responses[overallIndex]?.response_confidence ||
                                    "Please Select"}
                                </span>
                              </Form.Label>
                              <Form.Range
                                min="1"
                                max="10"
                                value={
                                  form.questions[currentQuestion]?.responses[overallIndex]?.response_confidence || 5
                                }
                                onChange={(e) =>
                                  handleChange({
                                    questionIndex: currentQuestion,
                                    questionText: questions[currentQuestion].question_text,
                                    responseIndex: overallIndex,
                                    responseWardIndex: wardIndex,
                                    responseWardName: ward,
                                    responseText: option.label,
                                    responseConf: e.target.value,
                                  })
                                }
                                style={{ marginTop: "-5px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Card.Body>
              </Card>
            );
          })}
        </Form.Group>
        <div className="navigation-buttons">
          {currentQuestion > 0 && (
            <Button variant="secondary" onClick={handleBack} className="nav-button">Back</Button>
          )}
          {!(isLastQuestion() && isCurrentQuestionAnswered()) && currentQuestion < questions.length - 1 && (
            <Button 
              variant="primary" 
              onClick={handleNext} 
              disabled={!isCurrentQuestionAnswered()}
              className="nav-button"
            >
              Next Question →
            </Button>
          )}
          {isLastQuestion() && isCurrentQuestionAnswered() && (
            <Button variant="primary" onClick={submitButton} className="nav-button-red">Submit</Button>
          )}
        </div>
        {/* Expandable debug section for form status (admin only) */}
        {isAdmin && (
          <div style={{ marginTop: "15px" }}>
            <h6
              style={{ cursor: "pointer", userSelect: "none" }}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              Current Form State{" "}
              {isExpanded ? (
                <span style={{ fontWeight: "normal" }}>▼</span>
              ) : (
                <span style={{ fontWeight: "normal" }}>▶</span>
              )}
            </h6>
            {isExpanded && (
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  background: "#f9f9f9",
                  padding: "10px",
                  marginTop: "8px",
                  border: "1px solid #ddd",
                }}
              >
                {JSON.stringify(form, null, 2)}
              </pre>
            )}
          </div>
        )}
        </Form> 
      )}
    </div>
  );
}
